import { Spinner } from "react-bootstrap";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { mappingsQuery, salaryMappingBatchPut } from "../../../../../api/index.js";
import { useDispatch } from "react-redux";
import { buildAlert } from "../../../../../actions/index.js";
import { SettingsProcountorContext } from "../SettingsProcountorContext.jsx";
import { Button } from "../../../../../common/Button.tsx";

export const BenefitMappingSave = ({ closeModal }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const {
    mutate,
    isPending: isEditingLoading,
    isSuccess: isEditingSuccess,
    isError: isEditingError,
    error,
  } = useMutation({
    mutationFn: (json) => salaryMappingBatchPut(json),
  });

  const { benefitEditedCells, setBenefitEditedCells } = useContext(SettingsProcountorContext);
  const { refetch } = useQuery(mappingsQuery);

  const editEventMapping = async () => {
    mutate(benefitEditedCells);
  };

  useEffect(() => {
    if (isEditingError && error) {
      dispatch(buildAlert("ERROR", error.code, error.message));
    }
  }, [isEditingError, error]);

  useEffect(() => {
    if (!isEditingSuccess) return;
    refetch().then(() => {
      setBenefitEditedCells([]);
      closeModal();
    });
  }, [isEditingSuccess]);

  return (
    <Button
      key="key"
      variant="outline-primary"
      onClick={editEventMapping}
      disabled={benefitEditedCells.length === 0}
      className="d-flex align-items-center gap-1"
    >
      {isEditingLoading && <Spinner animation="border" role="status" variant="light" size="sm" />}
      {t("Save", "Tallenna")}
    </Button>
  );
};
